import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import { Tooltip } from "../Tooltip";

import "./Resource.scss";
import { CreateResource } from "./CreateResource";

export const Resource = observer(
  ({ resource, onDelete, onUpdate, onChapterApply, mode = "view" }) => {
    const [isEditing, setIsEditing] = useState(false);
    const editorRef = useRef();

    useEffect(() => {
      const { name, link } = resource;
      editorRef.current?.setResource({ name, link });
    }, [isEditing]);

    const submitEditHandler = (newData) => {
      onUpdate({ ...resource, ...newData }).then((asyncSuccess) => {
        asyncSuccess && setIsEditing(false);
      });
    };

    return isEditing ? (
      <CreateResource
        ref={editorRef}
        mode="edit"
        onCancel={() => setIsEditing(false)}
        onSubmit={submitEditHandler}
      />
    ) : (
      <div className="resource d-flex justify-content-between align-items-center rounded-10 h-100">
        <a
          href={resource.link}
          target="_blank"
          className="flex-grow-1 d-flex align-items-center p-4"
        >
          <div className="icon me-3">
            <i className="fa-duotone fa-link fa-2x" />
          </div>
          <div className="d-flex flex-column">
            <div className="fw-bold text-dark">{resource.name}</div>
            <div className="fs-7 text-black-50 limit-line one-lines">
              {resource.link.toString().replace(/^(.*\/\/[^\/?#]*).*$/,"$1")}
            </div>
          </div>
        </a>

        {mode === "edit" && (
          <div className="d-flex flex-row align-items-center text-black-50 pe-4">
            <Tooltip title="Áp dụng toàn chương">
              <div
                role="button"
                className="resource-action d-flex align-items-center rounded border p-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onChapterApply(resource);
                }}
              >
                <i className="fa-duotone fa-list-tree"></i>
              </div>
            </Tooltip>
            <Tooltip title="Sửa">
              <div
                role="button"
                className="resource-action d-flex align-items-center rounded border p-2 ms-2"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsEditing(true);
                }}
              >
                <i className="fa-duotone fa-pen"></i>
              </div>
            </Tooltip>
            <Tooltip title="Xoá">
              <div
                role="button"
                className="resource-action d-flex align-items-center rounded border p-2 ms-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(resource.id);
                }}
              >
                <i className="fa-duotone fa-trash"></i>
              </div>
            </Tooltip>
          </div>
        )}
      </div>
    );
  },
);
